export const CATEGORIES = {
  cinema: "películas / series / documentales",
  podcast: "podcasts",
  video: "video",
  book: "libros / artículos",
  app: "apps",
  products: "producto",
}
